/** @jsx jsx */
import { jsx } from "theme-ui"
import RetroHitCounter from "react-retro-hit-counter"
import presets from "../utils/presets"

export default function HitCounter({ hits }) {
  return (
    <div
      sx={{
        position: `fixed`,
        bottom: 75,
        right: 20,
        [presets.Tablet]: {
          bottom: 20,
        },
      }}
    >
      <RetroHitCounter
        hits={hits}
        withBorder={false}
        /* The following are all default values: */
        withGlow={true}
        minLength={6}
        size={22}
        padding={3}
        digitSpacing={2}
        segmentThickness={2}
        segmentSpacing={0.5}
        segmentActiveColor="#BF5FFF"
        segmentInactiveColor="#315324"
        backgroundColor={`#222222`}
        borderThickness={5}
        glowStrength={0.5}
      />
    </div>
  )
}
